// extracted by mini-css-extract-plugin
module.exports = {"deleteItemButtonLast":"arrayItemsFields_deleteItemButtonLast__3JCQp"};